module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/gift-subscription@2x_772840.jpg";